import { render, staticRenderFns } from "./CommonProviderList.vue?vue&type=template&id=2c1afdd7&scoped=true"
import script from "./CommonProviderList.vue?vue&type=script&lang=js"
export * from "./CommonProviderList.vue?vue&type=script&lang=js"
import style0 from "./CommonProviderList.vue?vue&type=style&index=0&id=2c1afdd7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1afdd7",
  null
  
)

export default component.exports